export { default } from './BarchartWidgetStackedBars';
